module.exports = __webpack_public_path__ + "img/12.0ca3a3a2.jpg";